<template>
  <div class="Reports__View">
    <EntityListLayout :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>בנק שאלות</template>
      <template #button>
        <a @click="addQuestion" class="link-button">
          שאלה חדשה
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import AdminService from "@/services/AdminService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import FieldService from "@/services/FieldService";
import FilterService from "@/services/FilterService";
import TableActions from "@/services/TableActionsService";
import QuestionEntity from "./QuestionEntity.vue";

export default {
  name: "QuestionsInBank",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const reportsFields = FieldService.list("questions");
      const reportsfilters = FilterService.list();

      const sideViewEntity = {
        component: QuestionEntity,
        preview: true,
        readOnly: false,
        title: "פרטי שאלה",
        recordTitle: 'הצג שאלה',
        recordUrl: "question",
      };
      const fields = [
        { ...reportsFields.Id, checked: true },
        { ...reportsFields.Question, checked: true },
        { ...reportsFields.EditorNotes, checked: true },
        { ...reportsFields.DifficultyLevel, checked: true },
        { ...reportsFields.DifficultyPercentage, checked: true },
        { ...reportsFields.IsDelta, checked: true },
        { ...reportsFields.IsInExam, checked: true },
        { ...reportsFields.PreviewQuestion, checked: true },
        { ...reportsFields.QuestionHistory, checked: true},
        { ...reportsFields.ModifiedDate, checked: false },
        { ...reportsFields.Entity, checked: false },
      ];

      this.tabs = [
        {
          id: "AdminQuestionsInBank",
          title: "כל השאלות",
          getDataAsync: this.getAllQuestions,
          perPage: 100,
          fields,
          filters: [
          { ...reportsfilters.QuestionsBankTerms },
          { ...reportsfilters.IsByCourseIdOnly},
          { ...reportsfilters.CourseId, isHidden: true },
          { ...reportsfilters.ExerciseId },
          { ...reportsfilters.AcademicInstituteId },
          // { ...reportsfilters.AuthorId },
          { ...reportsfilters.QuestionCategoryIds },
          { ...reportsfilters.MinimumStudentAnswers },
          { ...reportsfilters.HasOpenRequestsOnly },
          { ...reportsfilters.IsActive, selected: true },
          { ...reportsfilters.IsDelta },
          { ...reportsfilters.IsInExam },
          { ...reportsfilters.IsInactive },
          { ...reportsfilters.HasEditorNotesOnly },
          { ...reportsfilters.IsByQuestionsIds },
          { ...reportsfilters.MinimumDifficulty },
          { ...reportsfilters.MaximumDifficulty },
          { ...reportsfilters.ParagraphNumber },
          { ...reportsfilters.SearchFilterType },
          { ...reportsfilters.LawId },
          ],
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: true,
          tableActions: [
            TableActions.changeText,
            TableActions.exportQuestions,
            TableActions.exportQuestionsWithAnswers,
          ],
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש שאלה בבנק",
          },
          sideViewEntity,
          isAdminArea: true,
          defaultQuery: false
        },
      ];
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllQuestions({ cancelToken, ...rest }) {
      return AdminService.getQuestionsInBank(
        {
          ...rest,
        },
        cancelToken.token
      ).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
    addQuestion() {
      this.$router.push('/newQuestion');
    }
  },
};
</script>
<style lang="scss" scoped>
.Reports__View {
  height: 100%;

  .link-button {
    background: #00427e;
    border: none;
    border-radius: 3px;
    padding: 14px 25px;
    margin-left: 10px;
    color: white;
    cursor: pointer;
  }
}
</style>
